import { createFileRoute, redirect } from '@tanstack/react-router'
import EntityLinksView from '@migrate/components/navigator/EntityLinksView'

export const Route = createFileRoute('/_auth/entity/$entityId/_breadcrumbs/links')({
  component: RouteComponent,
  beforeLoad: ({ context: { scopedEnablements, scope } }) => {
    if (!scopedEnablements.for(scope).hasStandardEnablement('EntityLink', 'READ')) {
      throw redirect({
        from: Route.fullPath,
        to: '..',
        replace: true,
      })
    }
  },
})

function RouteComponent() {
  const { entity } = Route.useRouteContext()
  return <EntityLinksView entityDetail={entity} />
}
